"use client";
import React from "react";
import isEmpty from "lodash/isEmpty";
import { List, SimpleGrid, VStack } from "@chakra-ui/react";
import { Heading, Text } from "@/elements";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import BgImage from "public/shared/dotted-background-image.png";

type Props = {
  description?: string;
  list?: { label: string; text: string }[];
  title: string;
};

const PlainCard = (props: Props) => {
  const { description, list = [], title } = props;
  const HeadingVariant = useHeadingVariant();
  const textVariant = useTextVariant();
  const mid = Math.ceil(list.length / 2);
  const list1 = list.slice(0, mid);
  const list2 = list.slice(mid);
  return (
    <VStack
      backgroundColor="primary.200"
      bgImage={`url(${BgImage.src})`}
      backgroundPosition={"center"}
      backgroundSize={"cover"}
      backgroundRepeat="no-repeat"
      borderRadius={"16px"}
      className="brand-shadow"
      px={6}
      py={12}
      gap={6}
      _hover={{
        boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.3)",
        transform: "translateY(-5px) scale(1.02)",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <Heading as="h2" variant={HeadingVariant} textAlign={"center"} color="white" mb={6}>
        {title}
      </Heading>
      {description && (
        <Text
          lineHeight={"1.4"}
          maxW={"900px"}
          textAlign={"center"}
          variant={"body1"}
          color="white"
        >
          {description}
        </Text>
      )}
      {!isEmpty(list) && (
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          gap={8}
          width={{ base: "100%", lg: "80%" }}
        >
          {[list1, list2].map((list, index) => (
            <List.Root key={index} gap={3} color="white" listStyleType="disc">
              {list.map((item, itemIndex) => (
                <List.Item key={itemIndex}>
                  <Text as="span" fontWeight={600} variant={textVariant}>
                    {item.label} :{" "}
                  </Text>
                  <Text as="span" variant={textVariant}>
                    {item.text}
                  </Text>
                </List.Item>
              ))}
            </List.Root>
          ))}
        </SimpleGrid>
      )}
    </VStack>
  );
};

export default PlainCard;
